import '@assets/styles/tiptap-preview.css';

import PhotoGrayIcon from '@assets/images/common/image_dummy.svg';
import { SupportService } from '@src/api/types/supportService';
import { SnsShareButtons } from '@src/components/SnsShareButtons';
import { useProcessedTableContent } from '@src/hooks/useProcessedContent';
import LINKS from '@src/modules/constants/links';
import Button from '@src/ui/elements/button/Button';
import Tag from '@src/ui/elements/Company/Tag';
import React from 'react';
import { Link } from 'react-router-dom';

interface SupportServiceContentProps {
  supportService: SupportService;
  showApplicationButton?: boolean;
  showFloatingButton?: boolean;
  shareData: {
    url: string;
    title: string;
    tags: string[];
    disabled: boolean;
  } | null;
}

const SupportServiceContent: React.FC<SupportServiceContentProps> = ({
  supportService,
  shareData,
}) => {
  const processedContent = useProcessedTableContent(supportService?.content || '');

  const handleContactClick = () => {
    window.open(LINKS.CONTACT_BANK, '_blank');
  };
  return (
    <div>
      <div className='flex flex-row-reverse items-start justify-between lg:mt-10 md:flex-col-reverse md:gap-6'>
        <div className='flex w-[54%] flex-col items-start md:w-full'>
          <h1
            className='order-2 break-all pt-4 text-3xl font-bold leading-normal md:text-xl'
            data-testid='support-service-title'
          >
            {supportService?.title}
          </h1>
          <Link
            to={`/support-services?category_slug=${supportService?.support_service_category?.slug}`}
          >
            <p
              className='order-1 cursor-pointer border-b-2 border-solid border-b-primary py-1 text-[15px] text-primary'
              data-testid='support-service-category'
            >
              {supportService?.support_service_category?.name}
            </p>
          </Link>
          <ul
            className='order-3 flex flex-wrap gap-2 pt-6'
            style={{
              gridArea: 'tag',
            }}
          >
            {supportService?.support_service_tags.map((tag, index) => (
              <li key={index}>
                <Tag
                  to={`/support-services?tag_slug=${tag.slug}`}
                  label={tag.name}
                />
              </li>
            ))}
          </ul>
        </div>
        <div className='w-2/5 flex-[0_0_auto]  md:w-full'>
          <img
            className='aspect-[300/168] size-full object-contain'
            src={supportService?.thumbnail_url || PhotoGrayIcon}
            alt=''
            width={300}
            height={168}
            loading='lazy'
            data-testid='support-service-thumbnail'
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = PhotoGrayIcon;
            }}
          />
        </div>
      </div>
      <div className='mt-10 flex justify-center'>
        <Button
          size='s'
          fullRounded
          onClick={handleContactClick}
        >
          サービスのお問い合わせ・お申込みはこちら
        </Button>
      </div>
      <div
        className='tiptap-content mt-10 overflow-hidden break-all'
        dangerouslySetInnerHTML={{
          __html: processedContent,
        }}
        data-testid='support-service-content'
      />

      <div className='mt-10 flex justify-center'>
        <Button
          size='s'
          fullRounded
          onClick={handleContactClick}
        >
          サービスのお問い合わせ・お申込みはこちら
        </Button>
      </div>
      {shareData && (
        <div className='mt-10'>
          <SnsShareButtons
            url={shareData.url}
            title={shareData.title}
            tags={shareData.tags}
            disabled={shareData.disabled}
          />
        </div>
      )}
    </div>
  );
};

export default SupportServiceContent;
